import * as z from "zod";

export const createCin7CoreIntegration = {
  name: "createCin7CoreIntegration" as const,
  input: z.object({ accountId: z.string().min(1), apiKey: z.string().min(1) }),
  output: z.object({ success: z.boolean() }),
};
